import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { Col } from "react-bootstrap";
import { CheckGroup, Check, TextArea } from "MODULES/shared/components/Forms";
import { TEARDOWN } from "MODULES/RepairOrders/constants";
import { properCase } from "LIB/formatters/text";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import {
  CUSTOMER_TO_PROVIDE_OWN_PAPERWORK,
  DISCREET,
  PICTURES_REQUIRED,
  SPECIAL_INSTRUCTIONS
} from "../../../../constants";

export default function AdditionalDetails({
  lineItem = {},
  showSpecialInstructions = true,
  showDiscreet = true,
  disablePicturesRequired
}) {
  return (
    <div>
      {lineItem &&
        lineItem.action_requested !== TEARDOWN && (
          <FormRow>
            {showDiscreet && (
              <Col md={4}>
                <CheckGroup justified title={properCase(DISCREET)}>
                  <Field
                    name={DISCREET}
                    component={Check}
                    label={properCase(DISCREET)}
                  />
                </CheckGroup>
              </Col>
            )}
            <Col md={5}>
              <CheckGroup title="Customer to Provide Own P/W">
                <Field
                  name={CUSTOMER_TO_PROVIDE_OWN_PAPERWORK}
                  component={Check}
                  label="Customer to Provide Own P/W"
                />
              </CheckGroup>
            </Col>
            <Col md={3}>
              <CheckGroup title={properCase(PICTURES_REQUIRED)}>
                <Field
                  name={PICTURES_REQUIRED}
                  component={Check}
                  label={properCase(PICTURES_REQUIRED)}
                  disabled={disablePicturesRequired}
                />
              </CheckGroup>
            </Col>
          </FormRow>
        )}
      {showSpecialInstructions && (
        <FormRow>
          <Col md={12}>
            <Field
              name={SPECIAL_INSTRUCTIONS}
              component={TextArea}
              label="Special Instructions (For shipping team)"
              rows="5"
              cols="50"
            />
          </Col>
        </FormRow>
      )}
    </div>
  );
}

AdditionalDetails.propTypes = {
  disablePicturesRequired: PropTypes.bool,
  lineItem: PropTypes.shape({}),
  showDiscreet: PropTypes.bool,
  showSpecialInstructions: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/shared/FormSections/ShippingSection/AdditionalDetails.jsx